const {
	actions: { toggleModal },
} = window.Edocat.Components.ModalTest;

import Tr from './Tr';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
const { Table, TableBody, TableHead, TableCell, TableRow, Button, FormGroup, TableContainer } = window.Material;
const { Add } = window.MaterialIcons;
interface TableInnerProps extends ReduxComponentInterface, ControlInterface {
	params: any;
	formInstanceId: string;
	view: boolean;
	wholeTableDislplayValues: { [key: string]: string }[];
	error: string;
}

class TableInner extends React.PureComponent<TableInnerProps> {
	onNewClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, formInstanceId } = this.props;
		actions.toggleModal(
			true,
			`form${name}`,
			{
				isNew: true,
			},
			formInstanceId
		);
	};

	render() {
		const { wholeTableDislplayValues, value: wholeTableValues, params, name, formInstanceId, view, label, error } = this.props;

		return (
			<FormGroup className={"react-root Edocat-TableDetail" + (view ? " view" : " edit") + (error ? "Edocat-TableDetail edit table-border-error" : "")}>
				<label htmlFor={name} className={`MuiFormLabel-root table-label` + (view ? " view-form" : " edit") + (error ? `MuiFormLabel-root table-label table-error` : "")}>
					{label}
					{error ? ' *' : ''}
				</label>
				<div className='table-scroll'>
					<TableContainer className='table-wrap'>
						<Table stickyHeader aria-label="sticky table">
							<TableHead>
								<TableRow>
									{!view && <TableCell className="tableActionsCell">{window.Alfresco.messages.global['label.actions']}</TableCell>}
									{params.tableHeaders.map((it: { key: string; label: string }) => (
										<TableCell key={it.key}>{it.label}</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{!(Array.isArray(wholeTableValues) && wholeTableValues.length > 0) && (
									<TableRow>
										<TableCell
											colSpan={!view ? params.tableHeaders.length + 1 : params.tableHeaders.length}
											className="no-results-row"
										>
											{window.Alfresco.messages.global['edocat.text.no-results']}
										</TableCell>
									</TableRow>
								)}
								{(Array.isArray(wholeTableValues) && wholeTableValues.length > 0) &&
									wholeTableValues.map((it: { [key: string]: any }, index: number) => (
										<Tr
											index={index}
											row={it}
											headers={params.tableHeaders}
											wholeTableValues={wholeTableValues}
											rowDislplayValues={wholeTableDislplayValues[index]}
											name={name}
											formInstanceId={formInstanceId}
											isViewOnly={view}
											key={index}
										/>
									))}
								{!view && (
									<TableRow>
										<TableCell
											colSpan={!view ? params.tableHeaders.length + 1 : params.tableHeaders.length}
											className="no-results-row"
										>
											<Button
												className="form-table-add-button"
												startIcon={<Add />}
												onClick={this.onNewClick}
												variant="contained"
												disableElevation
												color="primary"
											>
												{window.Alfresco.messages.global['button.add']}
											</Button>
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</FormGroup>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ toggleModal }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(TableInner);
